// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607170633/js/" + chunkId + "." + {"44":"7b56827d","225":"77029e65","481":"98888042","486":"147cbb23","770":"51504ce4"}[chunkId] + ".0.45453835326365943.chunk.js";
};